module.exports = __webpack_public_path__ + "img/intersection-8@3x.03ff9a9e.png";